import React from 'react';
import { Link } from 'react-router-dom';

import TendersOnSale from './Sale';
import TendersOnReturnReceipt from './ReturnReceipt';
import TendersOnReturn from './Return';

const subRoutes = [TendersOnSale, TendersOnReturnReceipt, TendersOnReturn];

function Content() {
  return (
    <ol>
      {subRoutes.map((route) => (
        <li key={route.path}>
          <Link to={`${route.path}`}>{route.title}</Link>
        </li>
      ))}
    </ol>
  );
}

export default {
  title: 'Payment Tenders',
  description:
    'Choose the tendering methods available for a Sale, Return and Return without receipt. You can also set limits for cash, separate card payments and etc.',
  path: '/pos-settings/tenders',
  component: Content,
  subRoutes,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [{ name: 'Payment Tenders' }],
};
